import React from "react";
import { THIRD_PARTY_FULFILLMENTS } from "../../../variable";
import { FULFILLMENTS_SLUG } from "../../../constants";
import { UpdateShippingOption } from "./UpdateShippingOption";
import { Banner, Modal } from "@shopify/polaris";
import { useOrderContext } from "../OrdersPolaris";

export default function BlukUpdateShippingOption({
    open,
    orderIDs,
    onClose,
    handleCompleted,
}) {
    const { fulfillmentSlug } = useOrderContext() || {};
    const thirdPartyFF = THIRD_PARTY_FULFILLMENTS[fulfillmentSlug];
    const isPrintway = fulfillmentSlug === FULFILLMENTS_SLUG.Printway;
    const isPrintify = fulfillmentSlug === FULFILLMENTS_SLUG.Printify;
    const isPGPrints = fulfillmentSlug === FULFILLMENTS_SLUG.PGPrints;
    const isPrintBelle = fulfillmentSlug === FULFILLMENTS_SLUG.PrintBelle;

    const isValid = !!thirdPartyFF || isPrintway || isPrintify || isPGPrints;

    return isValid ? (
        <UpdateShippingOption
            open={open}
            onClose={onClose}
            orderIDs={orderIDs}
            refetch={handleCompleted}
            thirdPartyFF={thirdPartyFF}
            isPrintway={isPrintway}
            isPrintify={isPrintify}
            isPGPrints={isPGPrints}
            isPrintBelle={isPrintBelle}
            isBulkAction
        />
    ) : (
        <Modal
            open={open}
            onClose={onClose}
            title="Update shipping option"
            sectioned
        >
            <Banner
                title="Please choose Fulfillment provider valid"
                status="info"
            />
        </Modal>
    );
}
